import { LoadingError } from "client/src/components/Error/LoadingError";
import { useEffect } from "react";

import { useLocation } from "react-router";

import type { FallbackRender } from "@sentry/react";
import type { Location } from "react-router";

const generateUrl = (location: Location) => location.pathname + location.search + location.hash;

const eventToUrlMap: Map<string, string> = new Map();

// eslint-disable-next-line @typescript-eslint/unbound-method
export const BoundaryError: FallbackRender = ({ resetError, error, eventId }) => {
  const location = useLocation();

  useEffect(() => {
    const eventUrl = eventToUrlMap.get(eventId);
    const url = generateUrl(location);

    if (!eventUrl) {
      eventToUrlMap.set(eventId, url);
    } else {
      if (eventUrl !== url) {
        eventToUrlMap.delete(eventId);
        resetError();
      }
    }
  }, [location, eventId, resetError]);

  return <LoadingError type="page" error={error} />;
};
